import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHomePage_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHomePage_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isWeb: boolean;
  isWeb_dummy: boolean;
  isIOS: boolean;
  isIOS_dummy: boolean;
  isAndroid: boolean;
  isAndroid_dummy: boolean;
  LogMain: any;
  LogMain_dummy: any;
  TakvimGetir: any[];
  TakvimGetir_dummy: any[];
  DashBoardOzet: any[];
  DashBoardOzet_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  BakimGetir: any[];
  BakimGetir_dummy: any[];
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetUserRoles: any[];
  GetUserRoles_dummy: any[];
  BagHasKey: boolean;
  BagHasKey_dummy: boolean;
  GetFromBag_GIDISREZID: Guid;
  GetFromBag_GIDISREZID_dummy: Guid;
  Notify: boolean;
  Notify_dummy: boolean;
  ClearBag: boolean;
  ClearBag_dummy: boolean;
  AddUserToRole: boolean;
  AddUserToRole_dummy: boolean;
  RemoveUserFromRole: boolean;
  RemoveUserFromRole_dummy: boolean;
  isComp812015Visible: "visible" | "hidden";
  isComp950625Visible: "visible" | "hidden";
  isComp319879Visible: "visible" | "hidden";
  isComp752264Visible: "visible" | "hidden";
  isComp867974Visible: "visible" | "hidden";
  isComp143451Visible: "visible" | "hidden";
  isComp443968Visible: "visible" | "hidden";
  isComp370632Visible: "visible" | "hidden";
  isComp840582Visible: "visible" | "hidden";
  isComp21056Visible: "visible" | "hidden";
  isComp498878Enabled: "enabled" | "disabled";
  isComp206777Enabled: "enabled" | "disabled";
  isComp482921Enabled: "enabled" | "disabled";
  isComp72799Enabled: "enabled" | "disabled";
  isComp394327Enabled: "enabled" | "disabled";
  isComphomepage_871067AuthorizationVisible: "visible" | "hidden";
  isComphomepage_22351AuthorizationVisible: "visible" | "hidden";
  isComphomepage_56515AuthorizationVisible: "visible" | "hidden";
  isComphomepage_574055AuthorizationVisible: "visible" | "hidden";
  isComphomepage_408202AuthorizationVisible: "visible" | "hidden";
  isComphomepage_588253AuthorizationVisible: "visible" | "hidden";
  isComphomepage_44287AuthorizationVisible: "visible" | "hidden";
}

export class HomePage_ScreenBase extends React.PureComponent<
  IHomePage_ScreenProps,
  any
> {
  homepage_423231_value_kuikaCalendarRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "774e53bc-3e19-435c-92cd-14a51099c53b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 914070, PropertyName: "value", Value: "Flyart Uçuş Rezervasyon" },
        {
          Id: 97660,
          PropertyName: "value",
          Value: "Bugünkü Rezervasyon Sayısı",
        },
        {
          Id: 498878,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        {
          Id: 570321,
          PropertyName: "value",
          Value: "Onaylı Rezervasyon Sayısı",
        },
        {
          Id: 206777,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 726047, PropertyName: "value", Value: "Tamamlanan Uçuş Sayısı" },
        {
          Id: 482921,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 960003, PropertyName: "value", Value: "Son Taco" },
        {
          Id: 72799,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 949253, PropertyName: "value", Value: "Bakıma Kalan Taco" },
        {
          Id: 394327,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 481338, PropertyName: "label", Value: "Yeni Rezervasyon" },
        { Id: 726090, PropertyName: "label", Value: "Rezervasyonlar" },
        { Id: 103671, PropertyName: "label", Value: "Yeni Uçuş" },
        { Id: 585834, PropertyName: "label", Value: "Uçuşlar" },
        { Id: 195525, PropertyName: "label", Value: "Yeni Bakım" },
        { Id: 17250, PropertyName: "label", Value: "Bakımlar" },
        { Id: 214948, PropertyName: "value", Value: "Bu uygulama" },
        {
          Id: 696502,
          PropertyName: "value",
          Value: "tarafından geliştirilmiştir",
        },
        { Id: 950625, PropertyName: "label", Value: "Roller Getir" },
        { Id: 517982, PropertyName: "label", Value: "Donus" },
        { Id: 170089, PropertyName: "label", Value: "Bag Has Key" },
        { Id: 975979, PropertyName: "label", Value: "Bag Value" },
        { Id: 310117, PropertyName: "label", Value: "Pilot Rolü Al" },
        { Id: 754399, PropertyName: "label", Value: "Mali İşlerRolü  Al" },
        { Id: 777254, PropertyName: "label", Value: "Yolcu Rolü Al" },
        { Id: 226195, PropertyName: "label", Value: "Asistan Rolü Al" },
        { Id: 814375, PropertyName: "label", Value: "Teknisyen Rolü Al" },
        { Id: 139803, PropertyName: "label", Value: "Admin Rolü Al" },
        { Id: 846865, PropertyName: "label", Value: "Rolleri Göster" },
        { Id: 865912, PropertyName: "label", Value: "Rolleri Çıkar" },
        {
          Id: 443968,
          PropertyName: "value",
          Value:
            "* Rol ekleyip çıkardıktan sonra geçerli olması için sayfayı F5 ile yenileyiniz",
        },
        {
          Id: 840582,
          PropertyName: "value",
          Value:
            "* Üst bilgideki kullanıcı adına tıklanınca, geçerli olan rolleri görünür.",
        },
        { Id: 21056, PropertyName: "placeholder", Value: "Type here..." },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";
  HomePageRecuringAction_15_Interval: any;

  constructor(props) {
    super(props);
    this.homepage_498878_value_kuikaTextInputRef = React.createRef();
    this.homepage_206777_value_kuikaTextInputRef = React.createRef();
    this.homepage_482921_value_kuikaTextInputRef = React.createRef();
    this.homepage_72799_value_kuikaTextInputRef = React.createRef();
    this.homepage_394327_value_kuikaTextInputRef = React.createRef();
    this.homepage_423231_value_kuikaCalendarRef = React.createRef();
    this.homepage_21056_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      isWeb: false,
      isIOS: false,
      isAndroid: false,
      LogMain: "",
      TakvimGetir: [],
      DashBoardOzet: [],
      TriggerEvent: "",
      BakimGetir: [],
      IfThenElse: false,
      GetUserRoles: [],
      BagHasKey: false,
      Notify: false,
      GetFromBag_GIDISREZID: "",
      AddUserToRole: false,
      RemoveUserFromRole: false,
      isComp812015Visible: "hidden",
      isComp950625Visible: "hidden",
      isComp319879Visible: "hidden",
      isComp752264Visible: "hidden",
      isComp867974Visible: "hidden",
      isComp143451Visible: "hidden",
      isComp443968Visible: "hidden",
      isComp370632Visible: "hidden",
      isComp840582Visible: "hidden",
      isComp21056Visible: "hidden",
      isComp498878Enabled: "disabled",
      isComp206777Enabled: "disabled",
      isComp482921Enabled: "disabled",
      isComp72799Enabled: "disabled",
      isComp394327Enabled: "disabled",
      isComphomepage_871067AuthorizationVisible: "visible",
      isComphomepage_22351AuthorizationVisible: "visible",
      isComphomepage_56515AuthorizationVisible: "visible",
      isComphomepage_574055AuthorizationVisible: "visible",
      isComphomepage_408202AuthorizationVisible: "visible",
      isComphomepage_588253AuthorizationVisible: "visible",
      isComphomepage_44287AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HomePagePageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_871067AuthorizationVisible",
      [
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "cf733353-6d36-8127-9f8b-a3aed724696b",
        "FLYPILOT",
        "FLYTEKNISYEN",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_22351AuthorizationVisible",
      [
        "bc213756-d4cb-041c-d830-01a910450129",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "e1393ac7-79a1-8995-202f-8c208b60d9b6",
        "FLYASISTAN",
        "FLYPILOT",
        "FLYMALIISLER",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_56515AuthorizationVisible",
      ["876aca55-06cb-93ae-aef3-28611f7f08a4", "FLYPILOT"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_574055AuthorizationVisible",
      [
        "bc213756-d4cb-041c-d830-01a910450129",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "e1393ac7-79a1-8995-202f-8c208b60d9b6",
        "FLYASISTAN",
        "FLYPILOT",
        "FLYMALIISLER",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_408202AuthorizationVisible",
      [
        "cf733353-6d36-8127-9f8b-a3aed724696b",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "FLYPILOT",
        "FLYTEKNISYEN",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_588253AuthorizationVisible",
      ["cf733353-6d36-8127-9f8b-a3aed724696b", "FLYTEKNISYEN"]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isComphomepage_44287AuthorizationVisible",
      [
        "cf733353-6d36-8127-9f8b-a3aed724696b",
        "876aca55-06cb-93ae-aef3-28611f7f08a4",
        "FLYPILOT",
        "FLYTEKNISYEN",
      ]
    );

    if (true) {
      if (false) {
        await this.HomePageRecuringAction_15_();
      }
      this.HomePageRecuringAction_15_Interval = setInterval(async () => {
        await this.HomePageRecuringAction_15_();
      }, 15000);
    }

    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (this.HomePageRecuringAction_15_Interval) {
      clearInterval(this.HomePageRecuringAction_15_Interval);
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("homepage", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HomePagePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      homepage_498878_value:
        this.state.DashBoardOzet?.at?.(0)?.bugunAdet ?? undefined,
      homepage_206777_value:
        this.state.DashBoardOzet?.at?.(0)?.planliAdet ?? undefined,
      homepage_482921_value:
        this.state.DashBoardOzet?.at?.(0)?.tamamlananAdet ?? undefined,
      homepage_72799_value:
        this.state.DashBoardOzet?.at?.(0)?.sonTaco ?? undefined,
      homepage_394327_value:
        this.state.DashBoardOzet?.at?.(0)?.bakimTaco ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HomePagePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isWeb = await ReactSystemFunctions.isWeb();
    stateVars.isIOS = await ReactSystemFunctions.isIOS();
    stateVars.isAndroid = await ReactSystemFunctions.isAndroid();

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePagePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      konu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Ana Sayfa", "string"),
        "string"
      ),
      mesaj_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      IsWeb_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.isWeb),
        "boolean"
      ),
      IsIOS_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.isIOS),
        "boolean"
      ),
      IsAndroid_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.isAndroid),
        "boolean"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePagePageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TakvimGetir = result?.data.takvimGetir;
    stateVars.DashBoardOzet = result?.data.dashBoardOzet;
    formVars.homepage_498878_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].bugunAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].bugunAdet
        : null
    );
    formVars.homepage_206777_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].planliAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].planliAdet
        : null
    );
    formVars.homepage_482921_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].tamamlananAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].tamamlananAdet
        : null
    );
    formVars.homepage_72799_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].sonTaco
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].sonTaco
        : null
    );
    formVars.homepage_394327_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].bakimTaco
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].bakimTaco
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePagePageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePagePageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.homepage_498878_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].bugunAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].bugunAdet
        : null
    );

    formVars.homepage_206777_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].planliAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].planliAdet
        : null
    );

    formVars.homepage_482921_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].tamamlananAdet
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].tamamlananAdet
        : null
    );

    formVars.homepage_72799_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].sonTaco
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].sonTaco
        : null
    );

    formVars.homepage_394327_value = ReactSystemFunctions.toString(
      this,
      stateVars.DashBoardOzet !== undefined
        ? stateVars.DashBoardOzet?.length > 0
          ? stateVars.DashBoardOzet[0].bakimTaco
          : null
        : this.state.DashBoardOzet?.length > 0
        ? this.state.DashBoardOzet[0].bakimTaco
        : null
    );

    stateVars.dataSource_423231 =
      stateVars.TakvimGetir ?? this.state.TakvimGetir;
    stateVars.dataSource_423231 =
      stateVars.TakvimGetir ?? this.state.TakvimGetir;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    await this.HomePageRecuringAction_15_();
    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HomePageComponent_226733_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "436413",
      null,
      "left",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_481338_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(null, "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_726090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "Murettebat",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "Yolcu",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "IsUcusYarat",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "RezervasyonListe",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_103671_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "Murettebat",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "Yolcu",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonListe",
      "IsUcusYarat",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "RezervasyonListe",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_585834_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "UcusDurum0",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "UcusDurum1",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "MasrafDurum0",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "MasrafDurum1",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "MasrafDurum2",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "UcusListe",
      "MasrafDurum3",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "UcusListe",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_195525_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BakimForm",
      "BakimId",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "BakimForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "BakimForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_17250_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "BakimListe",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_423231_onClickEvent = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "homepage_423231_value",
          "k_currentEvent.k_eventId"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_423231_onClickEvent",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BakimGetir = result?.data.bakimGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_423231_onClickEvent1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HomePageComponent_423231_onClickEvent_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonOzet",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "homepage_423231_value",
          "k_currentEvent.k_eventId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "RezervasyonOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "164009",
      null,
      "right",
      "true",
      "380px",
      "50vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  HomePageComponent_423231_onClickEvent_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BakimOzet",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "homepage_423231_value",
          "k_currentEvent.k_eventId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "BakimOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "891030",
      null,
      "right",
      "true",
      "380px",
      "50vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  HomePageComponent_423231_onClickEvent1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].id
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.HomePageComponent_423231_onClickEvent_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.HomePageComponent_423231_onClickEvent_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_950625_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      username_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HomePage/HomePageComponent_950625_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserRoles = result?.data.getUserRoles;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  HomePageComponent_517982_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.BagHasKey = await ReactSystemFunctions.bagHasKey(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HomePageComponent_517982_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HomePageComponent_517982_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetFromBag_GIDISREZID = await ReactSystemFunctions.getFromBag(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string")
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(this, stateVars.GetFromBag_GIDISREZID),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.ClearBag = await ReactSystemFunctions.clearBag(this.wfa);
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "CrudMode",
      ReactSystemFunctions.convertToTypeByName(2, "number")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "IsDonus",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "RezervasyonForm",
      "OrjId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetFromBag_GIDISREZID),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "RezervasyonForm",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  HomePageComponent_517982_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.BagHasKey),
        true
      )
    ) {
      isErrorOccurred = await this.HomePageComponent_517982_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_170089_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.BagHasKey = await ReactSystemFunctions.bagHasKey(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string")
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(this, stateVars.BagHasKey),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_975979_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetFromBag_GIDISREZID = await ReactSystemFunctions.getFromBag(
      this.wfa,
      ReactSystemFunctions.convertToTypeByName("GIDISREZID", "string")
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(this, stateVars.GetFromBag_GIDISREZID),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_310117_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYPILOT", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_754399_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYMALIISLER", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_777254_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYYOLCU", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_226195_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYASISTAN", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_814375_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYTEKNISYEN", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_139803_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.AddUserToRole = await ReactSystemFunctions.addUserToRole(
      ReactSystemFunctions.convertToTypeByName("FLYADMIN", "string"),
      ReactSystemFunctions.getMyUsername()
    );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_846865_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.getMyRoleNames(),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageComponent_865912_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYMUDUR", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYYOLCU", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYPILOT", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYASISTAN", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYTEKNISYEN", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYMALIISLER", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    stateVars.RemoveUserFromRole =
      await ReactSystemFunctions.removeUserFromRole(
        ReactSystemFunctions.convertToTypeByName("FLYADMIN", "string"),
        ReactSystemFunctions.getMyUsername()
      );
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HomePage",
      "HomePage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HomePageRecuringAction_15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.HomePageComponent_517982_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      436413,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HomePagePageInit();
    }
  }
}
